import { render } from "./SurveyTakerSection.vue?vue&type=template&id=33815efa"
import script from "./SurveyTakerSection.vue?vue&type=script&lang=js"
export * from "./SurveyTakerSection.vue?vue&type=script&lang=js"

import "./SurveyTakerSection.vue?vue&type=style&index=0&id=33815efa&scope=css&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__